export default __webpack_public_path__ + "static/autorPng-a37ef957b9ef3b71a375215a56f2d800.png";